import { jsonldOrganizerUrl } from './JsonldStore';

export const updateJsonldOrganizerUrl = (value) => jsonldOrganizerUrl.update((oldValue) => value);
